export var DocsBlockRichTextEditorPropertyStyle;
(function (DocsBlockRichTextEditorPropertyStyle) {
    /** Ordered list */
    DocsBlockRichTextEditorPropertyStyle["ol"] = "OL";
    /** Unordered list */
    DocsBlockRichTextEditorPropertyStyle["ul"] = "UL";
    /** Bold text */
    DocsBlockRichTextEditorPropertyStyle["bold"] = "Bold";
    /** Italic text */
    DocsBlockRichTextEditorPropertyStyle["italic"] = "Italic";
    /** Hyperlink */
    DocsBlockRichTextEditorPropertyStyle["link"] = "Link";
    /** Strikethrough text */
    DocsBlockRichTextEditorPropertyStyle["strikethrough"] = "Strikethrough";
    /** Inline code (mark) */
    DocsBlockRichTextEditorPropertyStyle["inlineCode"] = "InlineCode";
})(DocsBlockRichTextEditorPropertyStyle || (DocsBlockRichTextEditorPropertyStyle = {}));
